import { gql } from "graphql-request";

export namespace Queries {
    export const getTransaction = gql`
            query($transactionId: UUID!) {
                transaction(transactionId: $transactionId) {
                    data {
                        contact {
                            identifier
                        }
                    }
                    authorizationError{
                        message
                        helpMessage
                    }
                    authenticationError{
                        message
                        helpMessage
                    }
                    notFoundError {
                        message
                        helpMessage
                    }
                    fieldErrors {
                        field
                        message
                        helpMessage
                    }
                }
            }
        `;

    export const payTransactionViaCard = gql`
            mutation (
                $transactionId: UUID!,
                $customerCreditCardId: UUID!
            ) {
                payDebitViaCreditCard(
                    input: {
                        debitId: $transactionId
                        customerCreditCardId: $customerCreditCardId
                    }
                ) {
                    message
                    transaction {
                        identifier
                        states {
                            state
                        }
                        customerCreditCard {
                            brand
                            last4
                        }
                        creditCardFee
                    }
                    notFoundError {
                        message
                    }
                    fieldErrors{
                        field
                        message
                        helpMessage
                    }
                }
            }
        `;
}


